var Backbone, SharedFooterUSPhoneNumberView, SharedPhoneNumberTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedPhoneNumberTemplate = require('../../../../phone_number.html.mustache');

SharedFooterUSPhoneNumberView = (function(superClass) {
  extend(SharedFooterUSPhoneNumberView, superClass);

  function SharedFooterUSPhoneNumberView() {
    return SharedFooterUSPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSPhoneNumberView.prototype["class"] = 'support';

  SharedFooterUSPhoneNumberView.prototype.initialize = function(options) {
    if (options == null) {
      options = {};
    }
    this.I18nScope = 'modules.support';
    this.template = SharedPhoneNumberTemplate;
    return this.popupContainer = $("#popup");
  };

  SharedFooterUSPhoneNumberView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.popupContainer.html(this.el);
  };

  SharedFooterUSPhoneNumberView.prototype.toHash = function() {
    var deal, hash, ref, ref1;
    deal = ((ref = Groupon.Support) != null ? (ref1 = ref.currentOrder) != null ? ref1.DEAL_TYPE : void 0 : void 0) || null;
    hash = {
      showMRDealPhoneNumbers: deal === "GETAWAYS_MARKET_RATE",
      isLivingSocial: window.brand === "livingsocial"
    };
    if (deal === "GETAWAYS_MARKET_RATE") {
      TrackingHub.add("SUPPORT-APP-MARKET-RATE-CALL-US", {
        data: window.currentUser
      });
    }
    return hash;
  };

  SharedFooterUSPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterUSPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterUSPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterUSPhoneNumberView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9mb290ZXIvVVMvcGhvbmVfbnVtYmVyX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9mb290ZXIvVVMvcGhvbmVfbnVtYmVyX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsa0VBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2IseUJBQUEsR0FBNEIsT0FBQSxDQUFRLHdDQUFSOztBQUV0Qjs7Ozs7OzsyQ0FDSixPQUFBLEdBQU87OzBDQUVQLFVBQUEsR0FBWSxTQUFDLE9BQUQ7O01BQUMsVUFBVTs7SUFDckIsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7V0FDWixJQUFDLENBQUEsY0FBRCxHQUFrQixDQUFBLENBQUUsUUFBRjtFQUhSOzswQ0FLWixNQUFBLEdBQVEsU0FBQTtJQUNOLEdBQUcsQ0FBQyxLQUFLLENBQUMsSUFBVixDQUNFO01BQUEsRUFBQSxFQUFJLElBQUMsQ0FBQSxjQUFMO01BQ0EsY0FBQSxFQUFnQixJQURoQjtNQUVBLGFBQUEsRUFBZSxJQUZmO0tBREY7SUFJQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQVEsSUFBQyxDQUFBLFFBQVQsRUFBbUIsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFuQixFQUE4QixJQUFDLENBQUEsU0FBL0IsQ0FBWjtXQUNBLElBQUMsQ0FBQSxjQUFjLENBQUMsSUFBaEIsQ0FBcUIsSUFBQyxDQUFBLEVBQXRCO0VBTk07OzBDQVFSLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsOEVBQW9DLENBQUUsNEJBQS9CLElBQTRDO0lBQ25ELElBQUEsR0FDRTtNQUFBLHNCQUFBLEVBQXlCLElBQUEsS0FBUSxzQkFBakM7TUFDQSxjQUFBLEVBQWdCLE1BQU0sQ0FBQyxLQUFQLEtBQWdCLGNBRGhDOztJQUVGLElBQUcsSUFBQSxLQUFRLHNCQUFYO01BQ0UsV0FBVyxDQUFDLEdBQVosQ0FBZ0IsaUNBQWhCLEVBQW1EO1FBQUMsSUFBQSxFQUFNLE1BQU0sQ0FBQyxXQUFkO09BQW5ELEVBREY7O0FBRUEsV0FBTztFQVBEOzswQ0FTUixVQUFBLEdBQVksU0FBQTtJQUNWLEdBQUcsQ0FBQyxLQUFLLENBQUMsS0FBVixDQUFBO0FBQ0EsV0FBTztFQUZHOzswQ0FJWixNQUFBLEdBQ0U7SUFBQSxvQkFBQSxFQUF1QixZQUF2QjtJQUNBLGdCQUFBLEVBQW1CLFlBRG5COzs7OztHQTlCd0MsUUFBUSxDQUFDOztBQWlDckQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
